<template>
  <section class="custom-wrapper">
    <z-table :model-value="rows" class="table table-bordered table-sm" :columns="tableColumns">
      <template #tbody="props">
        <td class="text-center">
          <button class="btn btn-sm" type="button" title="edit" tabindex="-1" @click="$emit('edit', props.row)">
            <i class="far fa-edit"></i>
          </button>
        </td>
        <td>{{ props.row.adasBrokenLink }}</td>
        <td :class="getStatus(props.row, 'reportedStatus').class">{{ getStatus(props.row, 'reportedStatus').name }}</td>
        <td :class="getStatus(props.row).class">{{ getStatus(props.row).name }}</td>
        <td v-if="isValidated" :class="validationFor(props.row).class">{{ validationFor(props.row).name }}</td>
        <td class="custom-column-text">
          {{ cellText(props.row, 'name') }}
          <button v-if="canExpand(props.row, 'name')" class="btn btn-link custom-more" type="button" @click="toggleExpanded(props.row, 'name')">
            {{ isExpanded(props.row, 'name') ? 'less' : 'more' }}
          </button>
        </td>
        <td class="custom-column-text">
          <a v-if="props.row.url" :href="props.row.url" target="_blank" rel="noopener noreferrer">{{ cellText(props.row, 'url') }}</a>
          <button v-if="canExpand(props.row, 'url')" class="btn btn-link custom-more" type="button" @click="toggleExpanded(props.row, 'url')">
            {{ isExpanded(props.row, 'url') ? 'less' : 'more' }}
          </button>
        </td>
        <!-- <td>{{ clicksFor(props.row) }}</td> -->
        <td class="text-center">{{ props.row.timesReported }}</td>
        <td>{{ formatDate(props.row.createdOn) }}</td>
      </template>
      <template #empty> No links found! </template>
    </z-table>
  </section>
</template>
<script>
import globals from '@/plugins/globals'
import { getBrokenLinkStatus, clicksFor } from '@/plugins/broken-link-helper'
import ZTable from '@/components/utilities/elements/Table.vue'

// how much of the two free-text columns shows before the more/less toggle appears
const NAME_LIMIT = 40
const URL_LIMIT = 60

const NOT_VALIDATED = { name: '', class: '' }

export default {
  name: 'RepairLinkMembers',
  components: {
    ZTable
  },
  props: {
    row: {
      type: Object,
      default: null
    },
    links: {
      type: Array,
      default: () => []
    },
    source: {
      type: String,
      default: ''
    },
    validations: {
      type: Object,
      default: () => ({})
    },
    isValidated: {
      type: Boolean,
      default: false
    }
  },
  emits: ['edit'],
  data() {
    return {
      expanded: {}
    }
  },
  computed: {
    rows() {
      return this.links.length ? this.links : this.row ? [this.row] : []
    },
    tableColumns() {
      let columns = [
        { field: 'adasBrokenLink', label: '', sortable: false, class: 'custom-col-action' },
        { field: 'adasBrokenLink', label: 'Id', sortable: false, class: 'custom-col-id' },
        { field: 'reportedStatus', label: 'Reported Reason', sortable: false, class: 'custom-col-reason' },
        { field: 'status', label: 'Status', sortable: false, class: 'custom-col-status' },
        { field: 'display', label: 'Link Name', sortable: false, class: 'custom-col-name' },
        { field: 'url', label: 'Url', sortable: false, class: 'custom-col-url' },
        // { field: 'clicks', label: 'Clicks', sortable: false, class: 'custom-col-clicks' },
        { field: 'timesReported', label: 'Clicks', sortable: false, class: 'custom-col-reported' },
        { field: 'createdOn', label: 'Reported Date', sortable: false, class: 'custom-col-date' }
      ]
      if (this.isValidated) {
        columns.splice(4, 0, { field: 'validation', label: 'Validated', sortable: false, class: 'custom-col-validated' })
      }
      return columns
    }
  },
  methods: {
    getStatus(data, type = '') {
      return getBrokenLinkStatus(type === '' ? data.status : data.reportedStatus)
    },
    clicksFor(data) {
      return clicksFor(data)
    },
    validationFor(link) {
      return this.validations[`${this.source || ''}-${link.adasBrokenLink}`] || NOT_VALIDATED
    },
    formatDate(date) {
      return globals.formatDate(date, 'datetime')
    },
    fieldValue(row, field) {
      return field === 'url' ? row.url || '' : row.newDisplay || row.display || ''
    },
    fieldLimit(field) {
      return field === 'url' ? URL_LIMIT : NAME_LIMIT
    },
    canExpand(row, field) {
      return this.fieldValue(row, field).length > this.fieldLimit(field)
    },
    isExpanded(row, field) {
      return !!this.expanded[`${row.adasBrokenLink}:${field}`]
    },
    toggleExpanded(row, field) {
      const key = `${row.adasBrokenLink}:${field}`
      this.expanded[key] = !this.expanded[key]
    },
    cellText(row, field) {
      const value = this.fieldValue(row, field)
      if (this.isExpanded(row, field) || !this.canExpand(row, field)) {
        return value
      }
      return `${value.slice(0, this.fieldLimit(field))}…`
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  width: 100%;
  padding: 0.5rem;
}
.custom-wrapper :deep(table) {
  table-layout: fixed;
}
.custom-wrapper :deep(.custom-col-action) {
  width: 4%;
}
.custom-wrapper :deep(.custom-col-id) {
  width: 6%;
}
.custom-wrapper :deep(.custom-col-reason) {
  width: 11%;
}
.custom-wrapper :deep(.custom-col-status) {
  width: 9%;
}
.custom-wrapper :deep(.custom-col-validated) {
  width: 8%;
}
.custom-wrapper :deep(.custom-col-name) {
  width: 18%;
}
.custom-wrapper :deep(.custom-col-url) {
  width: 21%;
}
.custom-wrapper :deep(.custom-col-clicks) {
  width: 6%;
}
.custom-wrapper :deep(.custom-col-reported) {
  width: 7%;
  text-align: center;
}
.custom-wrapper :deep(.custom-col-date) {
  width: 10%;
}
.custom-column-text {
  word-break: break-all;
}
.custom-more {
  padding: 0;
  font-size: 0.85em;
  vertical-align: baseline;
}
</style>
